import { FrameWithStickyTitle } from 'components/BrandSlides/BrandSlides.jsx';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { ensureArray, safeMap, safeGetProp, ensureString, isNonEmptyArray } from 'utils/safeArray';

export default function Hero({ title, subtitle, image_url, content_image_url, paragraph, list_items = [], accent_color }) {
  const FALLBACK_IMAGE = 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg';
  const heroImage = content_image_url || image_url || FALLBACK_IMAGE;
  const safeListItems = ensureArray(list_items);
  const hasList = isNonEmptyArray(safeListItems);

  return (
    <FrameWithStickyTitle title={title} subtitle={subtitle} accentColor={accent_color}>
      <div className={`grid gap-4 md:gap-8 ${heroImage ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'}`}>
        <div className="flex flex-col gap-3 md:gap-5">
          {paragraph ? (
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">{ensureString(paragraph)}</p>
          ) : null}
          {hasList ? (
            <div className="flex flex-col gap-4 md:gap-6 justify-between min-h-[20vh] md:min-h-[30vh]">
              {safeMap(safeListItems, (it, idx) => (
                <div key={idx} className="grid grid-cols-[40px_1fr] md:grid-cols-[56px_1fr] gap-3 md:gap-4 items-center">
                  <div className="flex items-center justify-center">
                    <CheckCircleIcon className="h-10 w-10 md:h-14 md:w-14" style={{ color: accent_color || '#c00000' }} />
                  </div>
                  <div className="text-left">
                    <div className="text-base md:text-xl leading-snug font-semibold">{ensureString(safeGetProp(it, 'text'))}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
        {heroImage ? (
          <div className="relative w-full">
            <img
              src={ensureString(heroImage, FALLBACK_IMAGE)}
              alt=""
              className="w-full h-full max-h-[300px] md:max-h-[440px] object-cover rounded-xl shadow"
            />
          </div>
        ) : null}
      </div>
    </FrameWithStickyTitle>
  );
}


